import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./sitePages.css";
import useScrollReveal from "./useScrollReveal";
import schoolImage from "./Images/ecole2.avif";

function SchoolSolutions({ embedded = false }) {
  useScrollReveal();
  return (
    <div className="content-page">
      {!embedded && <Header />}

      <main className="content-main">
        <section className="page-hero page-hero-split">
          <div className="page-hero-copy">
            <h1>Solutions pour &eacute;coles</h1>
            <p>
              Une page d&eacute;di&eacute;e aux &eacute;tablissements scolaires
              pour acc&eacute;l&eacute;rer leur transformation num&eacute;rique
              avec SAMOL TECHNOLOGIES.
            </p>
          </div>
          <div className="page-hero-media reveal-on-scroll" data-reveal>
            <img
              src={schoolImage}
              alt="Etablissement scolaire modernise avec des solutions numeriques"
              loading="lazy"
            />
          </div>
        </section>

        <section className="content-grid">
          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>Smart-Educka</h3>
            <p>
              Plateforme de gestion scolaire int&eacute;gr&eacute;e :
              administration, suivi acad&eacute;mique, communication, pilotage
              et module d&apos;examen blanc avec affectation en salle,
              planification des places et restitution des r&eacute;sultats.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>Infrastructure scolaire</h3>
            <p>
              Installation et modernisation de salles informatiques,
              r&eacute;seaux et s&eacute;curit&eacute; du syst&egrave;me
              d&apos;information.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>Sites &eacute;coles</h3>
            <p>
              Conception de sites institutionnels et portails d&apos;inscription
              pour renforcer la visibilit&eacute; et les services en ligne.
            </p>
          </article>

          <article className="content-card reveal-on-scroll" data-reveal>
            <h3>Accompagnement num&eacute;rique</h3>
            <p>
              Cadrage, formation et support continu pour assurer
              l&apos;adoption durable des outils par les &eacute;quipes.
            </p>
          </article>
        </section>
      </main>

      {!embedded && <Footer />}
    </div>
  );
}

export default SchoolSolutions;
